import type { EstadoElevacaoPainel } from '../../dominio/didatico/elevacaoPainel'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { deArray } from '../../dominio/geometria/vetor3'
import { Barra } from '../componentes/Barra'
import { FaceDeCorte } from '../veiculo/Seccionado'
import { pontosElevacaoPainel } from './zonasElevacaoPainel'
import type { IdPortaOficina } from './zonasOperacaoPorta'

export function ColunaAElevada3D({ perfil, idPorta, estado }: { perfil: PerfilVeiculo; idPorta: IdPortaOficina; estado: EstadoElevacaoPainel }) {
  const p = pontosElevacaoPainel(perfil, idPorta, estado.alturaPainel, estado.progressoDobra)
  const id = `colunaA${idPorta.endsWith('Esquerda') ? 'Esquerda' : 'Direita'}`
  const mover = (y: number): [number, number, number] => { const v = p.coluna(y); return [v[0], v[1] + estado.alturaPainel, v[2] + estado.alturaPainel * 0.35] }
  const folga = 0.012
  const trechos = [
    [p.coluna(perfil.topoSoleiraY - 0.03), p.coluna(p.yInferior - (estado.corteBaseInferior ? folga : 0))],
    [mover(p.ySuperior + (estado.corteBaseSuperior ? folga : 0)), mover(perfil.cinturaY)],
    [mover(perfil.cinturaY), mover(p.yMedio - (estado.corteA ? folga : 0))],
    [p.coluna(p.yMedio + (estado.corteA ? folga : 0)), p.coluna(perfil.tetoY)],
  ]
  return <group name="coluna-a-elevacao">
    {trechos.map(([de, para], i) => <Barra key={i} id={id} de={deArray(de)} para={deArray(para)} largura={0.10} espessura={0.11} />)}
    <group name="aba-recortada-dobrada" position={p.inferior} rotation={[0, 0, -p.sinal * p.anguloDobra]}>
      <Barra id={id} de={deArray([0, estado.corteBaseInferior ? folga : 0, 0])}
        para={deArray([p.superior[0] - p.inferior[0], p.ySuperior - p.yInferior - (estado.corteBaseSuperior ? folga : 0), p.superior[2] - p.inferior[2]])} largura={0.10} espessura={0.11} />
      {estado.corteBaseSuperior && <FaceDeCorte posicao={[p.superior[0] - p.inferior[0], p.ySuperior - p.yInferior - folga, p.superior[2] - p.inferior[2]]} eixo="y" raio={0.052} />}
      {estado.corteBaseInferior && <FaceDeCorte posicao={[0, folga, 0]} eixo="y" raio={0.052} />}
    </group>
    {estado.corteA && <><FaceDeCorte posicao={mover(p.yMedio - folga)} eixo="y" raio={0.052} /><FaceDeCorte posicao={p.coluna(p.yMedio + folga)} eixo="y" raio={0.052} /></>}
    {estado.corteBaseSuperior && <FaceDeCorte posicao={mover(p.ySuperior + folga)} eixo="y" raio={0.052} />}
    {estado.corteBaseInferior && <FaceDeCorte posicao={p.coluna(p.yInferior - folga)} eixo="y" raio={0.052} />}
  </group>
}
